// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/deployer/v2/artifact_composition_service.proto (package ai.h2o.mlops.deployer.v2, syntax proto3)
/* eslint-disable */

import type { ArtifactComposition, ArtifactProcessor, DeployableArtifactType, ModelType } from "./artifact_composition_pb";
import { RPC } from "../../../../../runtime";

/**
 * The request message to list artifact compositions.
 * (-- api-linter: core::0158::request-page-token-field=disabled --)
 * (-- api-linter: core::0158::request-page-size-field=disabled --)
 * (-- api-linter: core::0132::request-parent-required=disabled --)
 *
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListArtifactCompositionsRequest
 */
export type ListArtifactCompositionsRequest = {
}
;
/**
 * The response message to return list of artifact compositions.
 * (-- api-linter: core::0158::response-next-page-token-field=disabled --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListArtifactCompositionsResponse
 */
export type ListArtifactCompositionsResponse = {
/**
 * List of artifact composition entities.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.ArtifactComposition artifact_compositions = 1;
 */
artifactCompositions?: ArtifactComposition[];
}
;
/**
 * The request message to list experiment's artifact compositions.
 * (-- api-linter: core::0158::request-page-token-field=disabled --)
 * (-- api-linter: core::0158::request-page-size-field=disabled --)
 * --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListExperimentArtifactCompositionsRequest
 */
export type ListExperimentArtifactCompositionsRequest = {
/**
 * The Experiment to represents requested experiment.
 *
 * @generated from field: string parent = 1;
 */
parent: string;
}
;
/**
 * The response message to return list of artifact compositions.
 * (-- api-linter: core::0158::response-next-page-token-field=disabled --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListExperimentArtifactCompositionsResponse
 */
export type ListExperimentArtifactCompositionsResponse = {
/**
 * List of artifact composition entities.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.ArtifactComposition experiment_artifact_compositions = 1;
 */
experimentArtifactCompositions?: ArtifactComposition[];
}
;
/**
 * The request message to list model types.
 * (-- api-linter: core::0158::request-page-token-field=disabled --)
 * (-- api-linter: core::0158::request-page-size-field=disabled --)
 * (-- api-linter: core::0132::request-parent-required=disabled --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListModelTypesRequest
 */
export type ListModelTypesRequest = {
}
;
/**
 * The response message to return list of model types.
 * (-- api-linter: core::0158::response-next-page-token-field=disabled --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListModelTypesResponse
 */
export type ListModelTypesResponse = {
/**
 * List of model type entities.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.ModelType model_types = 1;
 */
modelTypes?: ModelType[];
}
;
/**
 * The request message to list deployable artifact types.
 * (-- api-linter: core::0158::request-page-token-field=disabled --)
 * (-- api-linter: core::0158::request-page-size-field=disabled --)
 * (-- api-linter: core::0132::request-parent-required=disabled --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListDeployableArtifactTypesRequest
 */
export type ListDeployableArtifactTypesRequest = {
}
;
/**
 * The response message to return list of deployable artifact types.
 * (-- api-linter: core::0158::response-next-page-token-field=disabled --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListDeployableArtifactTypesResponse
 */
export type ListDeployableArtifactTypesResponse = {
/**
 * List of deployable artifact type entities.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.DeployableArtifactType deployable_artifact_types = 1;
 */
deployableArtifactTypes?: DeployableArtifactType[];
}
;
/**
 * The request message to list artifact processors.
 * (-- api-linter: core::0158::request-page-token-field=disabled --)
 * (-- api-linter: core::0158::request-page-size-field=disabled --)
 * (-- api-linter: core::0132::request-parent-required=disabled --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListArtifactProcessorsRequest
 */
export type ListArtifactProcessorsRequest = {
}
;
/**
 * The response message to return list of artifact processors.
 * (-- api-linter: core::0158::response-next-page-token-field=disabled --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListArtifactProcessorsResponse
 */
export type ListArtifactProcessorsResponse = {
/**
 * List of artifact processor entities.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.ArtifactProcessor artifact_processors = 1;
 */
artifactProcessors?: ArtifactProcessor[];
}
;
/**
 * List artifact compositions.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.ArtifactCompositionService.ListArtifactCompositions
 */
export const ArtifactCompositionService_ListArtifactCompositions = new RPC<ListArtifactCompositionsRequest,ListArtifactCompositionsResponse>("GET", "/v2/artifactCompositions");
/**
 * List artifact compositions supported by experiment.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.ArtifactCompositionService.ListExperimentArtifactCompositions
 */
export const ArtifactCompositionService_ListExperimentArtifactCompositions = new RPC<ListExperimentArtifactCompositionsRequest,ListExperimentArtifactCompositionsResponse>("GET", "/v2/{parent=workspaces/*/experiments/*}/artifactCompositions");
/**
 * List all known model types.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.ArtifactCompositionService.ListModelTypes
 */
export const ArtifactCompositionService_ListModelTypes = new RPC<ListModelTypesRequest,ListModelTypesResponse>("GET", "/v2/modelTypes");
/**
 * List all known deployable artifact types.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.ArtifactCompositionService.ListDeployableArtifactTypes
 */
export const ArtifactCompositionService_ListDeployableArtifactTypes = new RPC<ListDeployableArtifactTypesRequest,ListDeployableArtifactTypesResponse>("GET", "/v2/deployableArtifactTypes");
/**
 * List all known artifact processors.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.ArtifactCompositionService.ListArtifactProcessors
 */
export const ArtifactCompositionService_ListArtifactProcessors = new RPC<ListArtifactProcessorsRequest,ListArtifactProcessorsResponse>("GET", "/v2/artifactProcessors");
